<template>
  <a-config-provider :locale="locale">
    <router-view/>
  </a-config-provider>
</template>

<script>
import { i18nRender } from '@/locales';
import {mapState} from 'vuex';

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState('setting', ['lang']),
    locale() {
      // 切换语言时，更新标题
      let pageTitle = (this.$route.meta && this.$route.meta.title) ? i18nRender(this.$route.meta.title) : this.$route.name;
      document.title = pageTitle + ' - Boss Admin';

      return this.$i18n.getLocaleMessage(this.lang).antLocale;
    }
  }
}
</script>

